import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import styles from "../../stylesheets/components/separator-module.module.css";
import { BaseModuleProps, SeparatorModuleSettings } from "../../types/index.js";
import { css } from "../../utils/emotion.js";
import { getActiveColorScheme } from "../../utils/utils.js";
import SeparatorLine from "../SeparatorLine.js";
import SeparatorModuleIcons from "../SeparatorModuleIcons.js";

type Props = BaseModuleProps<SeparatorModuleSettings>;

const SeparatorModule: FunctionComponent<Props> = ({
  translatedModule,
  translatedModule: {
    settings: { width, height, icon, lineStyle, lineWeight },
  },
}) => {
  const scheme = useAppSelector((state) =>
    getActiveColorScheme(
      state.colorSchemes,
      getActiveSite(state.sites),
      translatedModule,
    ),
  );
  const isFullWidth = width === "full-width";
  const hasIcon = icon !== null;

  return (
    <div
      id={translatedModule.id}
      className={ClassNames(
        styles.SeparatorModule,
        moduleBaseStyles.Module,
        {
          [styles["SeparatorModule--height-small"]]: height === "small",
          [styles["SeparatorModule--height-medium"]]: height === "medium",
          [styles["SeparatorModule--height-big"]]: height === "big",
        },
        styles[`SeparatorModule--height-${height}`],
        css({ background: scheme.main.background, color: scheme.main.text }),
      )}
    >
      <div
        className={ClassNames(styles.SeparatorModule__Container, {
          [styles["SeparatorModule__Container--width-narrow"]]:
            width === "narrow",
          [moduleBaseStyles.Module__Wrapper]: !isFullWidth,
        })}
      >
        {hasIcon ? (
          <SeparatorModuleIcons
            translatedModule={translatedModule}
            scheme={scheme}
          />
        ) : (
          <SeparatorLine
            color={scheme.main.text}
            lineStyle={lineStyle}
            lineWeight={lineWeight}
            position="full"
          />
        )}
      </div>
    </div>
  );
};

export default SeparatorModule;
